import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Card1 from "../Images/Gallery/Lab1.jpg";
import Card3 from "../Images/Gallery/Lab2.jpg";

function TestingBioLiteCookstoves() {
  return (
    <div className="art-page">
      <SEO
        title="Testing of BioLite Cookstoves at the CIRCODU Cookstove Laboratory"
        description="CIRCODU Cookstove Testing Laboratory recently received 54 cookstove samples from BioLite, Kenya."
        keywords="BioLite cookstoves, CIRCODU, cookstove testing, greenhouse gas emissions, sustainable energy, Uganda, carbon finance, emissions reduction, clean energy, cookstove monitoring, carbon project development, independent monitoring organization, carbon credit verification, BioLite cookstoves Uganda, cookstove testing Uganda, greenhouse gas emissions reduction Uganda"
        url="/Testing-of-BioLite-Cookstoves-at-the-CIRCODU-Cookstove-Laboratory"
        image={Card1}
        datePublished="2024-07-31"
      />

      {/* ── Hero ──────────────────────────────────────── */}
      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Testing of BioLite Cookstoves
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Article body ──────────────────────────────── */}
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            {/* Date */}
            <div className="art-date">
              <span className="art-date__dot" />
              July 31, 2024
            </div>

            {/* Title */}
            <h1 className="art-title">
              Testing of BioLite Cookstoves at the CIRCODU Cookstove Laboratory
            </h1>

            {/* Body */}
            <div className="texty">
              <p>
                CIRCODU Cookstove Testing Laboratory recently received 54
                cookstove samples from BioLite, Kenya. These stoves were part of
                a Gold Standard Program of Activities aimed at quantifying
                greenhouse gas emissions reduction achieved through their use.
              </p>

              <img
                src={Card1}
                alt="BioLite cookstove testing in CIRCODU laboratory"
                className="art-img"
              />

              <p>
                The laboratory conducted a comprehensive monitoring study using
                Water Boiling Tests (WBTs) according to the Global Alliance for
                Clean Cookstoves WBT Version 4.2.3 Protocol. This study measured
                the stoves' thermal efficiency and fuel consumption.
              </p>

              <p>
                Utilizing calibrated equipment, the study provided robust data
                on the performance of various BioLite stove models and
                production years. The goal was to accurately determine the
                stoves' ability to reduce greenhouse gas emissions and improve
                fuel efficiency in households.
              </p>

              <img
                src={Card3}
                alt="Laboratory equipment and testing apparatus used for BioLite cookstoves"
                className="art-img"
              />
            </div>

            {/* CTA */}
            <div className="art-cta">
              <p>
                Are you interested in getting your Cookstoves Tested, Monitored
                and Evaluated? CIRCODU has the expertise and equipment to test
                Cookstove Efficiency, Safety, Durability, and Emissions. Stay
                tuned on our online platforms for more updates on our ongoing
                projects and initiatives! Contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call us on <a href="tel:+256392004309">+256 (0) 392 004 309</a>{" "}
                / <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>

            {/* Back */}
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TestingBioLiteCookstoves;
